import { AppUser, IAppUser } from "./app-user.model";
import { HouseFlat, IHouseFlat } from "./house-flat.model";
import { IStreetBuilding, StreetBuilding } from "./street-building.model";

export interface ISosLog {
  sosLogId: string;
  neighborhoodId: string;
  streetBuildingId: string;
  houseFlatId: string;
  os: string;
  version: string;
  brand: string;
  model: string;
  description: string;
  uidCreatedBy?: string;
  createdAt: string;
  streetBuilding: IStreetBuilding;
  houseFlat: IHouseFlat;
  createdBy?: IAppUser;
}

export class SosLog {
  sosLogId: string;
  neighborhoodId: string;
  streetBuildingId: string;
  houseFlatId: string;
  os: string;
  version: string;
  brand: string;
  model: string;
  description: string;
  uidCreatedBy?: string;
  createdAt: string;
  streetBuilding: StreetBuilding;
  houseFlat: HouseFlat;
  createdBy?: AppUser;

  constructor(data: ISosLog) {
    this.sosLogId = data.sosLogId;
    this.neighborhoodId = data.neighborhoodId;
    this.streetBuildingId = data.streetBuildingId;
    this.houseFlatId = data.houseFlatId;
    this.os = data.os;
    this.version = data.version;
    this.brand = data.brand;
    this.model = data.model;
    this.description = data.description;
    this.uidCreatedBy = data.uidCreatedBy;
    this.createdAt = data.createdAt;
    this.streetBuilding = new StreetBuilding(data.streetBuilding);
    this.houseFlat = new HouseFlat(data.houseFlat);
    this.createdBy = data.createdBy
      ? new AppUser(data.createdBy)
      : undefined;
  }
}
